closeSideMenuButton = {};

closeSideMenuButton.create = function() {
    var button = new PIXI.Container();
    
    InputHelpers.addGenerics(button);
    InputHelpers.addCanSpinFlag(button);
	
    button.canEnable = function() {
    	return true;
    };
    
    button.onPressedCallback = function() {
        let menuBar = resourceManager.get('buttonContainer:menuBar');
		menuBar.showMenuBarPanel(false);
    };

    return button;
};

closeSideMenuButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
};
closeSideMenuButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("closeSideMenuButton", closeSideMenuButton.create, closeSideMenuButton.initialise, closeSideMenuButton.getFilesRequired);